
import modal from "./modal"
export default  {
    namespaced:true,
    modules:{
        modal
    }
}